import GAnalyticsRepository from './GAnalyticsRepository';

export const gAnalytics = new GAnalyticsRepository();
